import React, { useState, useEffect, useRef } from "react";
import "./viewquery.scss";
import Sidebar from "../Sidebar";
import { querydetailAction, postqueryAction, addQueryCommentAction } from "../../actions/queryAction";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { decode } from "base-64";
import { notify } from '../../services/notification';
import Header from "../../component/loaderComponent/Header/Header";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { HTTP_STATUS } from "../../constants/httpsStatus/httpsStatus";
import { HiMenu, HiX } from "react-icons/hi";
import useMobileView from "../../constants/useMobileView";

function ViewQueryThreeWheelers() {
  const [state, setState] = useState({
    querydetail: {},
    Resolutions: "",
    adminComment: "",
  });
  const [attachments, setAttachments] = useState([]);
  const { isSidebarOpen, toggleSidebar } = useMobileView();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const decodedId = decode(id);
  const errorMessageRef = useRef(null);
  const [comments, setComments] = useState([]);

  useEffect(() => {
    fetchQueryDetail();
  }, []);

  const fetchQueryDetail = async () => {
    try {
      setLoading(true);
      const response = await dispatch(querydetailAction(decodedId));
      if (response?.status === HTTP_STATUS.SUCCESS) {
        const queryData = response.data.data[0];
        setState((prev) => ({
          ...prev,
          querydetail: queryData,
          query: queryData.query,
          category: queryData.category,
          user_name: queryData.user_name,
          description: queryData.description,
          mobile_number: queryData.mobile_number,
          pincode: queryData.pincode,
          email: queryData.email,
          created_at_date: queryData.created_at_date,
          created_at_time: queryData.created_at_time,
          resolution: queryData.resolution,
          status: queryData.status,
        }));
        setComments(queryData?.comments)
        setAttachments(queryData.attachment || []);
      } else {
        notify.error("Failed to load query details.");
      }
    } catch (error) {
      notify.error("Error fetching query details.");
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    if (!state.Resolutions) {
      setError("Resolution is required.");
      errorMessageRef.current?.scrollIntoView({ behavior: "smooth" });
      return false;
    }
    setError("");
    return true;
  };

  const handleCloseQuery = async () => {
    if (!validateForm()) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("status", "CLOSED");
    formData.append("resolution", state.Resolutions);
    formData.append("query_id", decodedId);
    const response = await dispatch(postqueryAction(formData));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      notify.success("Query has been marked as closed.");
      navigate("/3w/support/query");
    } else {
      notify.error("Failed to close the query.");
    }
    setLoading(false);
  };

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = url.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCancel = () => navigate("/3w/support/query");

  if (loading) return <Loader />;

  const { querydetail } = state;

  const handleAdminCommentChange = (e) => {
    const inputValue = e.target.value;
    // Count characters instead of words
    if (inputValue.length <= 100) {
      setState((prev) => ({ ...prev, adminComment: inputValue }));
    } else {
      // If exceeding 100 characters, truncate to the first 100 characters
      const truncatedText = inputValue.substring(0, 100);
      setState((prev) => ({ ...prev, adminComment: truncatedText }));
    }
  };

  const handleSaveAndCloseQuery = async () => {
    try {
      if (!state.adminComment.trim()) {
        notify.error("Comment cannot be empty!");
        return;
      }

      const newComment = {
        entity_type: "admin",
        comment: state.adminComment,
        created_at: new Date().toISOString(),
      };

      await dispatch(addQueryCommentAction(state.adminComment, decodedId));

      setComments((prevComments) => [...prevComments, newComment]);
      setState((prev) => ({ ...prev, adminComment: "" }));
      await fetchQueryDetail();

      if (!validateForm()) return;
      const formData = new FormData();
      formData.append("status", "CLOSED");
      formData.append("resolution", state.Resolutions);
      formData.append("query_id", decodedId);

      const response = await dispatch(postqueryAction(formData));
      if (response?.status === HTTP_STATUS.SUCCESS) {
        notify.success("Query has been saved and marked as closed.");
        navigate("/3w/support/query");
      } else {
        notify.error("Failed to close the query.");
      }
    } catch (error) {
      notify.error("An error occurred while saving or closing the query.");
    }
  };

  const formatTime = (timestamp) => {
    return new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'UTC'
    }).format(new Date(timestamp));
  };

  return (
    <div className="view-query-3w">
      <div className="Query_Containers">
        <div className="Query_Containers_right">
          <Header title="View Query" />
          <div className="PgmSpecial_Texts">
            <div className="TextConatinerDetails">
              <div className="TextContainerLeft">
                <InputField label="PGM Id" value={querydetail?.pgm} type="text" useTextarea={false} />
                <InputField label="PGM Name" value={querydetail?.user_name} type="text" useTextarea={false} />
                <InputField label="Query Title" value={querydetail.query} type="text" useTextarea={false} />
                <TextAreaField label="Query Description" value={querydetail.description} />
                <div className="Admin-comment">
                  {comments.length > 0 ? (
                    comments.map((comment, index) => (
                      <div key={index} className="comment-item">
                        {comment.entity_type === "admin" ? (
                          <InputFieldAdmin
                            label={`Admin Comment`}
                            tag={'admin'}
                            date={new Date(comment?.created_at).toLocaleDateString()}
                            time={formatTime(comment.created_at)}
                            value={comment?.comment}
                            readOnly
                          />
                        ) : (
                          <InputField
                            label={`PGM Comment`}
                            tag={'pgm'}
                            date={new Date(comment.created_at).toLocaleDateString()}
                            time={formatTime(comment.created_at)}
                            value={comment.comment}
                            readOnly
                            useTextarea={true}
                          />
                        )}
                      </div>
                    ))
                  ) : (
                    <p>No comments yet.</p>
                  )}

                  {querydetail?.status === 'OPEN' &&
                    (comments.filter((c) => c.entity_type === "admin").length < 3 && (
                      comments.length === 0 || comments[comments.length - 1].entity_type === "pgm"
                        ? (<div className="admin-comment-section">
                          <InputFieldAdmin
                            name="adminComment"
                            label="Admin Comment"
                            value={state.adminComment}
                            onChange={handleAdminCommentChange}
                            readOnly={false}
                          />
                        </div>)
                        : null
                    ))
                  }
                </div>
              </div>

              <div className="TextContainerRight">
                {querydetail?.dealers?.map((dealer) => (
                  <div key={dealer.id}>
                    <InputField label="Dealer ID" value={dealer.id} type="text" useTextarea={false} />
                    <InputField label="Dealer Name" value={dealer.name} type="text" useTextarea={false} />
                  </div>
                ))}
                <InputField label="Status" value={querydetail?.status} type="text" useTextarea={false} />
                <InputField label="Creation Date" value={querydetail?.created_at_date} type="date" useTextarea={false} />
                <InputField
                  label="Resolution Date"
                  value={querydetail?.comments?.length > 0
                    ? new Date(querydetail.comments[querydetail.comments.length - 1]?.created_at)
                      .toISOString()
                      .split("T")[0]
                    : ""}
                  type="date"
                  useTextarea={false}
                />
                <InputField label="Closed Date" value={querydetail?.closed_at?.split('T')[0]} type="date" useTextarea={false} />
                <AttachmentSection attachments={attachments} onDownload={handleDownload} />
              </div>

            </div>

            <div className="view-support-button">
              <button className="pgm_buttonPending_view" onClick={handleCancel}>
                Close
              </button>
              <button className="query_buttonclose" onClick={handleSaveAndCloseQuery} disabled={!state.adminComment.trim()}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const InputField = ({ label, value, time, date, type = "text", tag, readOnly, useTextarea = false }) => (
  <div className={`Label_name ${tag}`}>
    <label>{label}</label>
    <div className="date-time-format">
      <span>{date}</span>
      <span>{time}</span>
    </div>
    {useTextarea ? (
      <textarea
        value={value}
        className="input_field_query"
        readOnly={readOnly !== false}
      />
    ) : (
      <input
        type={type}
        value={value}
        className="input_field_query"
        readOnly={readOnly !== false}
      />
    )}
  </div>
);

const InputFieldAdmin = ({ label, value, date, time, type = "text", tag, onChange, readOnly }) => (
  <div className={`Label_name ${tag}`}>
    <label>{label}</label>
    <div className="date-time-format">
      <span>{date}</span>
      <span>{time}</span>
    </div>
    <textarea
      type={type}
      value={value}
      className="input_field_query"
      onChange={onChange}
      placeholder="Write your comment..."
      readOnly={readOnly}
    />
  </div>
);
const TextAreaField = React.forwardRef(({ label, value, onChange, name, error }, ref) => (
  <div className="Label_name">
    <label ref={ref}>
      {label} {error && <span style={{ color: "red" }}>* {error}</span>}
    </label>
    <textarea
      name={name}
      value={value}
      className="textareaInputbox"
      onChange={onChange}
      readOnly={!onChange}
    />
  </div>
));

const AttachmentSection = ({ attachments, onDownload }) => (
  <div style={{ "margin": "1rem" }}>
    <label>Attachments</label>
    {attachments.length > 0 ? (
      attachments.map((attach, i) => (
        <div>
          <div key={i} className="file_name">
            {/\.(jpg|png|webp)$/i.test(attach.attachment) ? (
              <img src={attach.attachment} alt="attachment" width="100" height="100" />
            ) : (
              <span title={attach.attachment.split("/").pop()}>{attach.name}</span>
            )}
          </div>
          <div>
            <span className="download_btn"
              onClick={() => onDownload(attach.attachment)}
            > Download</span>
          </div>
        </div>
      ))
    ) : (
      <p>No attachments available.</p>
    )}
  </div>
);

export default ViewQueryThreeWheelers;